var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"performance-trend"},[_c('div',{staticClass:"performance-trend-header"},[_vm._v("近15日趋势")]),_c('div',{staticClass:"performance-trend-diagram"},[_c('CChart',{attrs:{"options":_vm.chartOptions,"height":300}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }